import styled from 'styled-components';
import { Tag } from '@/ui';

export const StyledChip = styled(Tag)`
  cursor: pointer;
  font-family: monospace;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 0.375rem;
  user-select: none;
  white-space: normal;

  &:hover {
    opacity: 0.8;
  }
`;

export const StyledChipLabel = styled.span`
  flex: 1;
  word-break: break-all;
`;

export const StyledChipCopyIcon = styled.span`
  flex-shrink: 0;
  margin-top: 0.125rem;
`;
